
import { defineComponent } from "vue";

export default defineComponent({
    name: "CloseButton",
    props: {
        color: {
            type: String,
            default: "var(--white)"
        }
    }
});
